import createApolloClient from 'common/services/apolloClient';

const apolloClient = createApolloClient();

export default apolloClient;
